import { SelectedItem } from '@galaxy/inventory-ui';
import { ActivatableItemCount, ProductBoxItems } from '../core/interface';

export function ProductBoxItemsToSelectedItem(item: ProductBoxItems): SelectedItem {
  return {
    itemId: item.appId,
    type: 'app',
    name: item.name,
    iconUrl: item.icon,
    quantity: item.count,
    edition: {
      editionId: item.editionId,
      name: item.editionName,
    },
  };
}

export function ActivatableItemCountToSelectedItem(item: ActivatableItemCount): SelectedItem {
  const base: Pick<SelectedItem, 'itemId' | 'name' | 'iconUrl' | 'quantity'> = {
    itemId: item.activatableItem.appId,
    name: item.activatableItem.name,
    iconUrl: item.activatableItem.icon,
    quantity: item.quantity,
  };
  if (item.activatableItem.parentAppId) {
    return {
      ...base,
      type: 'addon',
      parentItemId: item.activatableItem.parentAppId,
    };
  }
  return {
    ...base,
    type: 'app',
    edition: {
      editionId: item.editionId,
      name: item.editionName,
    },
  };
}
